import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";

const vUI_Company_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_COMPANY_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'WB Company Id', columnResourceName: 'colId', alignment: HorizAlignment.Left},
        domainOptions: {}
    },
    COMPANY_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Company ID', columnResourceName: 'colUIId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    COMPANY_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Company Name',
            columnResourceName: 'colCompanyName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    ENTERPRISE_SET_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Enterprise Set ID',
            columnResourceName: 'colEnterpriseSetID',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    CITY: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'City',
            columnResourceName: 'colCity',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    COUNTRY: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Country',
            columnResourceName: 'colCountry',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    CURRENCY: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Default Currency',
            columnResourceName: 'colCurrency',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    LANGUAGE: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Language',
            columnResourceName: 'colLanguage',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const CompanySearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_COMPANY_ID',
        id_ui: 'COMPANY_ID',
        name: 'COMPANY_NAME'
    },

    searchProviderFields: vUI_Company_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                searchRequestSubset.where['WB_COMPANY_ID'] = {inq: _.map(usrContext.WB_Companies, 'WB_COMPANY_ID')}
            }

            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Company_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                });
        })
    },
    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            let searchRequestSubset: { where?: { [id: string]: any } } = {}
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                searchRequestSubset = {
                    where: {['WB_COMPANY_ID']: {inq: _.map(usrContext.WB_SalesOrgs, 'WB_COMPANY_ID')}}}
                }
                let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                    'vUI_Company_Search',
                    this.searchProviderFields,
                    [fieldName])


                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(_.map(res, (aRow) => {
                            return aRow[fieldName]
                        }))
                    })
                    .catch((err) => {
                        error(err)
                    })
            }
        )
        }
    };

    const CompanySearchProfileByName
:
ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "CompanySearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'COMPANY_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'COMPANY_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'COMPANY_ID', 'COMPANY_NAME', 'ENTERPRISE_SET_ID', 'CITY', 'COUNTRY', 'CURRENCY', 'LANGUAGE', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: CompanySearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const CompanySearch: ISearch = {
    searchName: "Find Company",
    renderOptions: {ui5ResourceId: "CompanySearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [CompanySearchProfileByName]
};

export {CompanySearch}